import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { Logo } from "./Logo";

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
        <div className="flex flex-col items-center gap-4">
          <Logo size="lg" />
          <div className="text-[#A0A0A0] text-sm animate-pulse">Loading…</div>
        </div>
      </div>
    );
  }
  // Preserve where the owner was headed (e.g. the EOD report deep link /reports?date=…) so login can
  // send them straight there instead of dropping them on the dashboard (J-5d). A login wall here is
  // correct — we keep the destination, we don't bypass it.
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/billing" replace />;
  return children;
}
